import { IEmergencyContactCommon } from './emergency-contact.interfaces';
import { Action } from '@ngrx/store';
import { EmergencyContact } from 'src/app/shared/models/emergency-contact';

export enum EmergencyContactActionTypes {
  FETCH_EMERGENCY_CONTACTS = '[EmergencyContact] Fetch Emergency Contacts',
  FETCH_EMERGENCY_CONTACTS_SUCCESS = '[EmergencyContact] Fetch Emergency Contacts Success',
  FETCH_EMERGENCY_CONTACTS_FAILURE = '[EmergencyContact] Fetch Emergency Contacts Failure',
  ADD_EMERGENCY_CONTACT = '[EmergencyContact] Add Emergency Contact',
  ADD_EMERGENCY_CONTACT_SUCCESS = '[EmergencyContact] Add Emergency Contact Success',
  ADD_EMERGENCY_CONTACT_FAILURE = '[EmergencyContact] Add Emergency Contact Failure',
  DELETE_EMERGENCY_CONTACT = '[EmergencyContact] Delete Emergency Contact',
  DELETE_EMERGENCY_CONTACT_SUCCESS = '[EmergencyContact] Delete Emergency Contact Success',
  DELETE_EMERGENCY_CONTACT_FAILURE = '[EmergencyContact] Delete Emergency Contact Failure',
  UPDATE_EMERGENCY_CONTACT = '[EmergencyContact] Update Emergency Contact',
  UPDATE_EMERGENCY_CONTACT_SUCCESS = '[EmergencyContact] Update Emergency Contact Success',
  UPDATE_EMERGENCY_CONTACT_FAILURE = '[EmergencyContact] Update Emergency Contact Failure',
  REMOVE_ALL_EMERGENCY_CONTACTS = '[EmergencyContact] Remove All Emergency Contacts'
}

export class FetchEmergencyContacts implements Action {
  readonly type = EmergencyContactActionTypes.FETCH_EMERGENCY_CONTACTS;
  constructor(public payload: number) {}
}

export class FetchEmergencyContactsSuccess implements Action {
  readonly type = EmergencyContactActionTypes.FETCH_EMERGENCY_CONTACTS_SUCCESS;
  constructor(public payload: IEmergencyContactCommon[]) {}
}

export class FetchEmergencyContactsFailure implements Action {
  readonly type = EmergencyContactActionTypes.FETCH_EMERGENCY_CONTACTS_FAILURE;
  constructor(public payload: string) {}
}

export class AddEmergencyContact implements Action {
  readonly type = EmergencyContactActionTypes.ADD_EMERGENCY_CONTACT;
  constructor(public payload: EmergencyContact) {}
}

export class AddEmergencyContactSuccess implements Action {
  readonly type = EmergencyContactActionTypes.ADD_EMERGENCY_CONTACT_SUCCESS;
  constructor(public payload: IEmergencyContactCommon) {}
}

export class AddEmergencyContactFailure implements Action {
  readonly type = EmergencyContactActionTypes.ADD_EMERGENCY_CONTACT_FAILURE;
  constructor(public payload: string) {}
}

export class DeleteEmergencyContact implements Action {
  readonly type = EmergencyContactActionTypes.DELETE_EMERGENCY_CONTACT;
  constructor(public payload: number) {}
}

export class DeleteEmergencyContactSuccess implements Action {
  readonly type = EmergencyContactActionTypes.DELETE_EMERGENCY_CONTACT_SUCCESS;
  constructor(public payload: number) {}
}

export class DeleteEmergencyContactFailure implements Action {
  readonly type = EmergencyContactActionTypes.DELETE_EMERGENCY_CONTACT_FAILURE;
  constructor(public payload: string) {}
}

export class UpdateEmergencyContact implements Action {
  readonly type = EmergencyContactActionTypes.UPDATE_EMERGENCY_CONTACT;
  constructor(public payload: EmergencyContact) {}
}

export class UpdateEmergencyContactSuccess implements Action {
  readonly type = EmergencyContactActionTypes.UPDATE_EMERGENCY_CONTACT_SUCCESS;
  constructor(public payload: IEmergencyContactCommon) {}
}

export class UpdateEmergencyContactFailure implements Action {
  readonly type = EmergencyContactActionTypes.UPDATE_EMERGENCY_CONTACT_FAILURE;
  constructor(public payload: string) {}
}

export class RemoveAllEmergencyContacts implements Action {
  readonly type = EmergencyContactActionTypes.REMOVE_ALL_EMERGENCY_CONTACTS;
}


export type EmergencyContactActions = FetchEmergencyContacts
| FetchEmergencyContactsFailure
| FetchEmergencyContactsSuccess
| AddEmergencyContact
| AddEmergencyContactSuccess
| AddEmergencyContactFailure
| UpdateEmergencyContact
| UpdateEmergencyContactSuccess
| UpdateEmergencyContactFailure
| RemoveAllEmergencyContacts
| DeleteEmergencyContact
| DeleteEmergencyContactSuccess
| DeleteEmergencyContactFailure;
